var render, staticRenderFns
import script from "./KintaiCardCommon.vue?vue&type=script&lang=ts&"
export * from "./KintaiCardCommon.vue?vue&type=script&lang=ts&"
import style0 from "./KintaiCardCommon.vue?vue&type=style&index=0&id=4eae6556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eae6556",
  null
  
)

export default component.exports